module.exports = __webpack_public_path__ + "d713ef88.svg";